import React, { Component } from 'react';
import HeaderButton from './HeaderButton';
import { getText, getParamByName } from '../config';

class FormHeader extends Component {
    render() {
        return (
            <div className="form-header">
                {!getParamByName('hotelsonly') && <HeaderButton
                    clickHandler={this.props.changeSearchType.bind(null, 'flight')}
                    type="flight"
                    title={getText('headerFlightButton')}
                    selected={this.props.searchType === 'flight'}
                    imgPath={this.props.imgPath}
                />}
                {!getParamByName('flightsonly') && <HeaderButton
                    clickHandler={this.props.changeSearchType.bind(null, 'hotel')}
                    type="hotel"
                    title={getText('headerPackageButton')}
                    selected={this.props.searchType === 'hotel'}
                    imgPath={this.props.imgPath}
                />}
            </div>
        );
    }
}

FormHeader.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default FormHeader;


// WEBPACK FOOTER //
// ./src/components/FormHeader.js